<template>
  <div class="mahai-auth">
    <div class="mahai-auth-card">
      <div class="mahai-auth-logo">
        <img :src="require('@/assets/images/ymlogo.png')" alt="Mahai" class="logo-img" />
      </div>

      <div class="lock-icon">
        <i class="material-symbols-outlined">lock</i>
      </div>

      <h2 class="mahai-auth-title">Ekran Kilitli</h2>
      <p class="mahai-auth-subtitle">Devam etmek için şifrenizi girin</p>

      <div class="user-info" v-if="displayName || email">
        <div class="user-avatar">
          {{ getInitials(displayName || email) }}
        </div>
        <span class="user-name">{{ displayName || email }}</span>
      </div>

      <form @submit.prevent="unlock" class="mahai-auth-form">
        <div class="form-group">
          <label>Şifre</label>
          <div class="input-wrapper">
            <i class="material-symbols-outlined input-icon">lock</i>
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              placeholder="Şifrenizi yazın"
              :disabled="loading"
              autocomplete="current-password"
              @keyup.enter="unlock"
            />
            <button
              type="button"
              class="toggle-pw"
              @click="showPassword = !showPassword"
              tabindex="-1"
            >
              <i class="material-symbols-outlined">
                {{ showPassword ? 'visibility_off' : 'visibility' }}
              </i>
            </button>
          </div>
        </div>

        <button type="submit" class="mahai-btn-primary" :disabled="loading || !email">
          <span v-if="!loading">Kilidi Aç</span>
          <span v-else>Açılıyor…</span>
        </button>

        <div v-if="message" class="mahai-alert success">{{ message }}</div>
        <div v-if="error" class="mahai-alert error">{{ error }}</div>

        <div class="alt-action">
          <a href="#" @click.prevent="logout">Farklı hesapla giriş yap</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  name: "LockScreen",
  data() {
    return {
      email: "",
      displayName: "",
      password: "",
      showPassword: false,
      loading: false,
      error: "",
      message: "",
    };
  },
  methods: {
    getInitials(name) {
      if (!name) return "?";
      if (name.includes("@")) {
        name = name.split("@")[0];
      }
      const parts = name.trim().split(/\s+/);
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      } else if (parts.length === 1 && parts[0].length >= 2) {
        return parts[0].substring(0, 2).toUpperCase();
      }
      return parts[0][0].toUpperCase();
    },

    async preloadUser() {
      const token = localStorage.getItem("auth_token");

      if (!token) {
        this.$router.replace("/authentication/sign-in");
        return;
      }

      try {
        const storedUser = localStorage.getItem("auth_user");
        if (storedUser) {
          const u = JSON.parse(storedUser);
          const fullName =
            u?.full_name || u?.name || u?.display_name || u?.email || "";
          this.displayName = fullName
            ? fullName.toString().trim().split(" ")[0]
            : "";
          this.email = u?.email || "";
        } else {
          this.displayName = "";
          this.email = "";
        }
      } catch (e) {
        this.displayName = "";
        this.email = "";
      }
    },

    async unlock() {
      this.error = "";
      this.message = "";

      if (!this.email || !this.password) {
        this.error = "Şifre zorunludur.";
        return;
      }

      this.loading = true;
      try {
        const response = await axios.post(`${API_BASE_URL}/auth/login`, {
          email: this.email,
          password: this.password,
        });

        const data = response?.data || {};

        if (data.token) {
          localStorage.setItem("auth_token", data.token);
        }
        if (data.user) {
          localStorage.setItem("auth_user", JSON.stringify(data.user));
        }

        window.dispatchEvent(new Event("auth-changed"));

        this.message = "Kilidiniz açıldı. Yönlendiriliyorsunuz…";

        const redirect = this.$route.query.redirect || "/apps/decisions-ai";
        setTimeout(() => this.$router.push(redirect), 600);
      } catch (e) {
        const status = e?.response?.status;
        const msg =
          e?.response?.data?.message || e?.message || "";

        if (status === 429 || String(msg).toLowerCase().includes("too many")) {
          this.error =
            "Çok sık deneme yapıldı. Lütfen birkaç dakika sonra tekrar deneyin.";
        } else if (
          status === 401 ||
          status === 422 ||
          String(msg).toLowerCase().includes("invalid")
        ) {
          this.error = "Şifre hatalı.";
        } else {
          this.error = "Kilidi açarken bir hata oluştu.";
        }
      } finally {
        this.loading = false;
      }
    },

    async logout() {
      try {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_user");
        window.dispatchEvent(new Event("auth-changed"));
      } catch (e) {
        // sessiz geç
      }

      this.$router.replace("/authentication/sign-in");
    },
  },
  async mounted() {
    try {
      await this.preloadUser();
    } catch (_) {
      // Sessizce geç
    }
  },
};
</script>

<style lang="scss" scoped>
.mahai-auth {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
  padding: 20px;
}

.mahai-auth-card {
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border-radius: 16px;
  padding: 48px 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.mahai-auth-logo {
  margin-bottom: 24px;

  .logo-img {
    height: 128px;
    width: auto;
    object-fit: contain;
  }
}

.lock-icon {
  margin-bottom: 16px;

  i {
    font-size: 48px;
    color: #f59e0b;
    background: #fef3c7;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

.mahai-auth-title {
  font-size: 24px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 8px;
}

.mahai-auth-subtitle {
  font-size: 15px;
  color: #64748b;
  margin: 0 0 24px;
}

.user-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
  padding: 14px 20px;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .user-name {
    font-size: 15px;
    font-weight: 600;
    color: #334155;
  }
}

.mahai-auth-form {
  text-align: left;

  .form-group {
    margin-bottom: 20px;

    label {
      display: block;
      font-size: 14px;
      font-weight: 600;
      color: #334155;
      margin-bottom: 8px;
    }
  }

  .input-wrapper {
    display: flex;
    align-items: center;
    background: #f8fafc;
    border: 1.5px solid #e2e8f0;
    border-radius: 10px;
    padding: 0 14px;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:focus-within {
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      background: #fff;
    }

    .input-icon {
      font-size: 20px;
      color: #94a3b8;
      margin-right: 10px;
      flex-shrink: 0;
    }

    input {
      flex: 1;
      border: none;
      background: transparent;
      padding: 13px 0;
      font-size: 15px;
      color: #0f172a;
      outline: none;

      &::placeholder {
        color: #94a3b8;
      }

      &:disabled {
        opacity: 0.6;
      }
    }

    .toggle-pw {
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px;
      color: #94a3b8;
      display: flex;
      align-items: center;
      transition: color 0.2s;

      &:hover {
        color: #475569;
      }

      i {
        font-size: 20px;
      }
    }
  }

  .mahai-btn-primary {
    width: 100%;
    padding: 14px;
    border: none;
    border-radius: 10px;
    background: linear-gradient(135deg, #3b82f6, #2563eb);
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
    margin-top: 8px;

    &:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 16px rgba(37, 99, 235, 0.4);
    }

    &:active:not(:disabled) {
      transform: translateY(0);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .mahai-alert {
    margin-top: 16px;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;

    &.success {
      background: #f0fdf4;
      color: #166534;
      border: 1px solid #bbf7d0;
    }

    &.error {
      background: #fef2f2;
      color: #991b1b;
      border: 1px solid #fecaca;
    }
  }

  .alt-action {
    text-align: center;
    margin-top: 20px;

    a {
      font-size: 14px;
      font-weight: 500;
      color: #3b82f6;
      text-decoration: none;
      transition: color 0.2s;

      &:hover {
        color: #2563eb;
        text-decoration: underline;
      }
    }
  }
}

@media only screen and (max-width: 480px) {
  .mahai-auth-card {
    padding: 32px 24px;
  }

  .mahai-auth-logo .logo-img {
    height: 96px;
  }

  .mahai-auth-title {
    font-size: 20px;
  }

  .lock-icon i {
    font-size: 40px;
    width: 64px;
    height: 64px;
  }
}
</style>
